module.exports = __webpack_public_path__ + "img/icon6.47aa04e6.png";